import { ExternalServiceApi } from "models/ExternalServiceApi";
import type { Moment } from "moment";
import { Model } from "react3l-common";
import { Field, MomentField } from "react3l-decorators";

export class LoggingApi extends Model {
  @Field(Number)
  public id?: number;

  @Field(String)
  public requestBody?: string;

  @Field(String)
  public requestHeader?: string;

  @Field(String)
  public responseStatus?: string; // chua co

  @Field(String)
  public responseBody?: string;

  @Field(Number)
  public retryCount?: number;

  @MomentField()
  public createdAt?: Moment;

  @Field(String)
  public requestUuid?: string;

  public externalServiceApi?: ExternalServiceApi;

  @Field(Number)
  public externalServiceApiId?: number;
  
}
